import { Machine } from 'stent';
let activated = false;
export const activateMachineLogger = function() {
    if (activated) {
        return;
    }
    Machine.addMiddleware({
        onStateChanged () {
            const isFailureState = this.state.name.toLowerCase().indexOf('failure') >= 0;
            if (isFailureState) {
                console.warn(`"${this.name}" machine state changed to ${this.state.name}`);
            }
            if (this.state.error) {
                console.error(this.state.error);
            }
        }
    });
    activated = true;
};
